<!--
 * @Author: your name
 * @Date: 2020-07-22 16:44:22
 * @LastEditTime: 2021-03-01 15:03:19
 * @LastEditors: Please set LastEditors
 * @Description: 填空题  E 
 * @FilePath     : \vue-gaokao-ebook\src\components\paper\question\assessment\assessment.vue
--> 
<template>
  <div :class="{ title: !isComposite, title_c: isComposite }">
    <div class="question_type" :id="'anchor' + question.id">
      <div class="id">{{ question.originalName }}</div>
      <div class="cricle"></div>
      <div class="mask"></div>
      <div class="name">
        <template v-if="isShowCorrectBtn">
          <div class="get-score">
            <div class="text">自评得分：</div>
            <div class="select">
              <div :class="{ gray_right: assStatus != 0, right: assStatus == 0 }" @click="setScore(0, question.score)">
              </div>
              <div :class="{
                gray_right_error: assStatus != 1,
                right_error: assStatus == 1,
              }" @click="setScore(1, -1)"></div>
              <div :class="{ gray_error: assStatus != 2, error: assStatus == 2 }" @click="setScore(2, 0)"></div>
            </div>
            <el-input placeholder="半对时输入分值" style="float: left; font-size: 12px; height: 42px; width: 124px"
              @change="checkScore" v-model="score"></el-input>
            <!-- 字号功能 -->
            <div class="demo-input-suffix divs" v-if="!isComposite">
              <span class="text">字号：</span>
              <el-select popper-class="font-set" v-model="setFontSize" placeholder="请选择" @change="selectFontSize">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </template>
        题型 : {{ filterType(question.typeId) }}
        <span class="score">分数 : {{ question.score }}</span>
      </div>
    </div>
    <div class="question_content">
      <div class="topic" :style="`font-size:${setFontSize}px`" :id="'question_content_' + question.id">
        <div class="format_data_gaicuo" v-if="question.typeId == 39 || question.typeId == 230"
          v-html="formatData(question.stem, question.id)"></div>
        <div v-else class="text" v-html="manipulateData(question.stem)"></div>

        <vue-audio v-if="question.listeningPath && showAudio" :key="question.listeningPath"
          :url="`${backURL}/apis/upload/${question.listeningPath}`" :duration="question.duration" :qid="question.id">
        </vue-audio>
      </div>
      <ul class="options">
        <li class="option text" v-for="(option, index) in question.gkQuestionOptions" :key="index"
          v-html="option.letter + '. ' + manipulateDataOptions(option.content)"
          :style="`font-size:${setFontSize}px !important;`"></li>
      </ul>

      <div class="wrong_topic" v-if="showAnalysis">
        <div class="left">
          <div class="assessment" style="border-color: #cf99ff">
            <div class="texts" style="
                color: #cf99ff;
                padding-left: 15px;
                border-bottom-color: #cf99ff;
                background-color: #f6edfe;
              ">
              我的作答
            </div>
            <div class="radios">
              <div class="content">
                <div class="solution" v-if="!q.self_answer" :style="`font-size: ${setFontSize}px`">
                  未作答
                </div>
                <div v-else class="solution images _view_image" style="overflow: auto"
                  :style="`font-size: ${setFontSize}px`" v-html="manipulateData(q.self_answer)"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="right">
          <div class="assessment top" style="border-color: #7eb8ff">
            <div class="texts" style="
                color: #7eb8ff;
                padding-left: 15px;
                border-bottom-color: #7eb8ff;
                background-color: #deedff;
              ">
              参考答案
            </div>
            <div class="radios radios-top">
              <div class="content">
                <div class="solution" v-if="!q.answer" style="height: auto" :style="`font-size: ${setFontSize}px`">
                  无参考答案
                </div>
                <div v-else class="solution" v-html="manipulateData(manipulateDataOptions(q.answer))"
                  style="height: auto" :style="`font-size: ${setFontSize}px`"></div>
              </div>
            </div>
          </div>

          <div class="assessment bottom" style="border-color: #25a801">
            <div class="texts" style="
                color: #25a801;
                padding-left: 15px;
                border-bottom-color: #25a801;
                background-color: #e2ffda;
              ">
              解析
            </div>
            <div class="radios radios-bottom">
              <div class="content">
                <div class="solution" v-if="!q.analysis" style="height: auto" :style="`font-size: ${setFontSize}px`">
                  略
                </div>
                <div v-else class="solution" v-html="manipulateData(analysisOptions(q.analysis))" style="height: auto"
                  :style="`font-size: ${setFontSize}px`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-image-viewer v-if="dialogVisible" :on-close="() => { dialogVisible = false }" :url-list="imgs">
      </el-image-viewer>
    </div>
  </div>
</template>

<script>
import vueAudio from "@/components/audio/index"
import questionHandle from "@/assets/js/question-handle";
import typeNameMap from "@/assets/js/composite_question_type.js"
import $ from "jquery";
// import affix from "@/components/affix/affix";
export default {
  data() {
    return {
      showAudio: true,
      imgIndex: 0,
      imgs: [],
      types: [],
      typeEdit: '',
      img_tags: [],
      dialogVisible: false,
      q: {},
      assStatus: 3,
      question_type: "",
      setFontSize: 20,
      affixShow: false,
      backURL: this.$config.backURL,
      options: [
        {
          value: 18,
          label: "小",
        },
        {
          value: 20,
          label: "标准",
        },
        {
          value: 22,
          label: "大",
        },
        {
          value: 24,
          label: "较大",
        },
        {
          value: 26,
          label: "超大",
        },
      ],
      score: "",
    };
  },
  components: {
    vueAudio,
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  props: {
    question: {
      type: Object,
    },
    isComposite: {
      type: Boolean,
      default: false,
    },
    isShowCorrectBtn: {
      type: Boolean,
      default: true,
    },
    showAnalysis: {
      type: Boolean,
      default: true,
    },
    compositeTypeId: {
      type: Number
    },
    compositeId: {
      type: Number
    }
  },
  // components: {
  //   affix,
  // },
  methods: {
    //图片预览
    prev() {
      this.imgIndex = this.imgIndex - 1;
    },
    next() {
      this.imgIndex = this.imgIndex + 1;
    },
    formatData(stem, id) {
      if (stem.indexOf("【改错开始】") != -1) {
        let str = "";
        str = stem.replace(/【改错开始】/, `<div id="gaicuo-${id}" class="gaicuo" style="max-width:1300px">`);
        str = str.replace(/【改错结束】/, "</div>");
        return str;
      } else {
        return stem;
      }
    },
    selectFontSize(val) {
      this.$root.eventHub.$emit("fontsize", val);
    },
    manipulateData(val) {
      // let reg = /font-size:\d+\.?\d*pt/g;
      // let res;
      // if (val) {
      //   res = val.replace(reg, `font-size:${this.setFontSize}px`);
      // }
      // return res;
      let reg = /font-size:\d+\.?\d*pt/g
      if (val && val != undefined) {
        let str = val.replace(reg, `font-size:${this.setFontSize}px`)
        let res4 = /font-size:(\d+\.?\d*?)px;([^<>]*?)vertical-align:sub;?/g
        let subValue = str.replace(res4, 'font-size:14px;$2vertical-align:sub;')
        let res5 = /font-size:(\d+\.?\d*?)px;([^<>]*?)vertical-align:super;?/g
        let supValue = subValue.replace(res5, 'font-size:14px;$2vertical-align:super;')
        return supValue
      } else {
        return ''
      }
    },
    formatQuestion(ques) {
      this.q = questionHandle.formatQuestion(ques);
    },
    checkScore() {
      var str = this.score.replace(/[^\d\.]/g, '');
      var pointIndex = str.search(/\./);
      //先判断是否超过了范围
      if (this.score > this.q.score) {
        str = this.q.score;
      } else if (this.score < 0) {
        str = 0;
      }

      //如果有小数,则以0.5位基准
      if (-1 !== pointIndex) {
        str = str.substr(0, pointIndex + 1).replace(/\./, ".5");
      }
      //给处理过的分数重新赋值
      this.score = str;
      //根据分数来改变图形样式
      if (this.score == this.q.score) {
        this.setScore(0, this.score);
      } else if (this.score < this.q.score && this.score > 0) {
        this.setScore(1, this.score);
      } else {
        this.setScore(2, 0);
      }
    },
    setScore(level, score) {
      this.assStatus = level;
      if (score != -1) {
        this.score = Number(score);
        this.q.auditStatus = true;
        if (this.score == this.q.score) {
          this.q.correct = true;
        } else {
          this.q.correct = false;
        }
        this.$root.eventHub.$emit(
          "self-assessment-changed",
          this.q.original,
          this.score,
          this.q.auditStatus,
          this.q.correct
        );
      } else {
        this.score = "";
        this.q.auditStatus = false;
        this.q.correct = false;
        this.$root.eventHub.$emit(
          "self-assessment-changed",
          this.q.original,
          -1,
          this.q.auditStatus,
          this.q.correct
        );
      }
    },
    changeAffix(affixed) {
      this.affixShow = affixed;
    },
    manipulateDataOptions(val) {
      let str = val.trimHeadTailTag("body").trimHeadTailTag("div");
      let reg1 = /<span[^>]*(?:\/>|>(?:&#xa0;)*<\/span>)/  // 去除空span
      let noPdom = str.replace(reg1, '');
      let reg2 = /<p[^>]*(?:\/>|>(?:\s|&nbsp;)*<\/p>)/ // 去除空p
      let Pdom = noPdom.replace(reg2, '')
      let res3 = /^<p[^>]*>(((?!<\/p >).)*)<\/p>/ // 去除两头p
      let values = Pdom.replace(res3, '$1')
      return values
    },
    analysisOptions(val) {
      let str = val.trimHeadTailTag("body").trimHeadTailTag("div");
      let reg1 = /<span[^>]*(?:\/>|>(?:&#xa0;)*<\/span>)/  // 去除空span
      let noPdom = str.replace(reg1, '');
      let reg2 = /<p[^>]*(?:\/>|>(?:\s|&nbsp;)*<\/p>)/ // 去除空p
      let Pdom = noPdom.replace(reg2, '')
      return Pdom
    },
    filterType(key) {
      let reStr = "解答题"
      for (let i in typeNameMap) {
        if (i == key) {
          reStr = typeNameMap[i];
          this.questionTypeName = reStr;
        }
      }
      return reStr;
    },
  },
  watch: {
    question: function (newVal) {
      this.formatQuestion(newVal);
      const _this = this;
      this.imgs = []
      this.img_tags = []
      $("._view_image").delegate('img', 'click', function () {
        _this.typeEdit = []
        _this.imgs = []
        _this.img_tags = $("._view_image").find("img");
        for (let i = 0; i < _this.img_tags.length; i++) {
          if (_this.img_tags[i].src == this.src) {
            _this.imgIndex = i;
          }
          _this.imgs.push(_this.img_tags[i].src);
          // let typeStr = ''
          // if(_this.img_tags[i].attributes['height'].nodeValue != null && _this.img_tags[i].attributes['height'].nodeValue)  {
          //   typeStr = _this.img_tags[i].attributes['height'].nodeValue
          // } else {
          //   typeStr = ''
          // }
          // _this.types.push(typeStr);
        }
        _this.imgIndex = _this.imgIndex;
        _this.url = _this.imgs[_this.imgIndex];
        _this.imgs.splice(_this.imgIndex, 1)
        _this.imgs.unshift(_this.url)
        if (_this.imgs[0] && _this.imgs[0] != undefined) {
          _this.dialogVisible = true;
        }
        // _this.typeEdit = _this.types[_this.imgIndex] || ''
      })
    },
  },
  created() {
    let path = this.$route.path
    if (path == '/paper/paper' || path == '/continue_evaluation' || path == '/continue_evaluation_zj' || path == '/paper/paper_ts') {
      this.showAudio = false
    }
  },
  mounted() {
    const _this = this;
    this.imgs = []
    this.img_tags = []
    setTimeout(() => {
      const _this = this;
      this.imgs = []
      this.img_tags = []
      $('#anchor' + this.question.id).find("._view_image").delegate('img', 'click', function () {
        _this.typeEdit = []
        _this.imgs = []
        _this.img_tags = $("._view_image").find("img");
        for (let i = 0; i < _this.img_tags.length; i++) {
          if (_this.img_tags[i].src == this.src) {
            _this.imgIndex = i;
          }
          _this.imgs.push(_this.img_tags[i].src);
          let typeStr = ''
          // if(_this.img_tags[i].attributes['height'].nodeValue != null && _this.img_tags[i].attributes['height'].nodeValue)  {
          //   typeStr = _this.img_tags[i].attributes['height'].nodeValue
          // } else {
          //   typeStr = ''
          // }
          // _this.types.push(typeStr);
        }
        _this.imgIndex = _this.imgIndex;
        _this.url = _this.imgs[_this.imgIndex];
        _this.imgs.splice(_this.imgIndex, 1)
        _this.imgs.unshift(_this.url)
        if (_this.imgs[0] && _this.imgs[0] != undefined) {
          _this.dialogVisible = true;
        }
        // _this.typeEdit = _this.types[_this.imgIndex] || ''
      })
    })

    this.formatQuestion(this.question);
    let typeId = this.question.typeId;
    let typeCode = this.question.typeCode;
    if (typeId == 40) {
      this.question_type = "七选五";
    } else if (typeId == 39) {
      this.question_type = "改错题";
    } else if (typeId == 9) {
      this.question_type = "作文";
    } else if (typeId == 24) {
      this.question_type = "书面表达";
    } else if (typeId == 20) {
      this.question_type = "阅读理解";
    } else if (typeId == 23) {
      this.question_type = "选词填空";
    } else if (typeId == 19) {
      this.question_type = "完形填空";
    } else if (typeId == 12) {
      this.question_type = "计算题";
    } else if (typeId == 42) {
      this.question_type = "语法填空";
    } else if (typeId == 103) {
      this.question_type = "判断题";
    } else if (typeId == 140) {
      this.question_type = "听力选择";
    } else {
      if (typeCode == "A") {
        this.question_type = "单选题";
      }
      if (typeCode == "B") {
        this.question_type = "多选题";
      }
      if (typeCode == "C") {
        this.question_type = "判断题";
      }
      if (typeCode == "S") {
        this.question_type = "解答题";
      }
      if (typeCode == "M") {
        this.question_type = "复合题";
      }
      if (typeCode == "E") {
        this.question_type = "填空题";
      }
    }

    //填空题主观题,客观题都在这里处理
    if (this.question.typeCode == "E" && this.question.blankCount > 1) {
      let originAnswerLength = eval('(' + this.question.answer + ')').length;
      let start = eval('(' + this.question.answer + ')')[0].orderno
      console.log("start=>", start)
      if (typeof this.question.answer != "string") {
        try {
          this.question.answer = JSON.stringify(this.question.answer)

          let handledAnswer1 = eval('(' + this.question.answer + ')');
          // originAnswerLength = handledAnswer1.length;
          let showStringAnswer1 = "";
          if (handledAnswer1) {
            handledAnswer1.forEach((item) => {
              showStringAnswer1 += `<p>${item.orderno}. ${item.answer}</p>`;
            });
            this.question.answer = showStringAnswer1;
          }
        }
        catch (err) {
          console.log(err)
        }
      } else {
        let handledAnswer1 = eval('(' + this.question.answer + ')');
        let showStringAnswer1 = "";
        if (handledAnswer1) {
          handledAnswer1.forEach((item) => {
            showStringAnswer1 += `<p>${item.orderno}. ${item.answer}</p>`;
          });
          this.question.answer = showStringAnswer1;
        }
      }
      if (typeof this.question.analysis != "string") {
        this.question.analysis = JSON.stringify(this.question.analysis)
      }
      try {
        let handledAnswer2 = JSON.parse(this.question.analysis);
        let showStringAnswer2 = "";
        if (handledAnswer2.length) {
          handledAnswer2.forEach((item) => {
            showStringAnswer2 += `<p>${item.orderno}. ${item.analysis}</p>`;
          });
          this.question.analysis = showStringAnswer2;
        }
      } catch (err) {
        console.log(err)
      }
      // if (this.question.answerUnicity) {
      //   let showStringAnswer = "";
      //   let paper_answers = [];
      //   if (typeof this.question.self_answer != "string") {
      //     this.question.self_answer = JSON.stringify(this.question.self_answer)
      //     let handledAnswer = eval('(' + this.question.self_answer + ')'); //此处是字符串,要转化为json,数据的最后有一个多余的逗号,使用JSON.parse解析会报错,要用eval来解析
      //     if (handledAnswer) {

      //       handledAnswer.forEach((item) => {
      //         if (!item.answer) item.answer = "未作答";
      //         let questionNum = +this.question.originalName.split('-')[0] || 1
      //         showStringAnswer += `<p>${item.orderno + (questionNum - 1)}. ${item.answer}</p>`;
      //       });
      //       this.question.self_answer = showStringAnswer;
      //     }
      //   } else {
      //     let handledAnswer = eval('(' + this.question.self_answer + ')'); //此处是字符串,要转化为json,数据的最后有一个多余的逗号,使用JSON.parse解析会报错,要用eval来解析
      //     if (handledAnswer) {
      //       handledAnswer.forEach((item) => {
      //         if (item.self_self_answer != null && item.self_self_answer.length) {
      //           showStringAnswer += `<p>${item.orderno}. ${item.self_self_answer}</p>`;
      //         } else {
      //           if (!item.self_answer) item.self_answer = "未作答";
      //           let questionNum = +this.question.originalName.split('-')[0] || 1
      //           showStringAnswer += `<p>${item.orderno + (questionNum - 1)}. ${item.self_answer}</p>`;
      //         }
      //       });
      //       this.question.self_answer = showStringAnswer;
      //     }
      //   }
      // } else {
      let showStringAnswer = ''
      let handledAnswer = eval('(' + this.question.self_answer + ')'); //此处是字符串,要转化为json,数据的最后有一个多余的逗号,使用JSON.parse解析会报错,要用eval来解析
      let originalName = this.question.originalName;
      // let start = originalName.split("-")[0]
      handledAnswer = handledAnswer.slice(0, originAnswerLength);
      if (handledAnswer.length) {
        handledAnswer.forEach((item, index) => {
          showStringAnswer += `<p>${+start + index}. ${item.self_answer || '未作答'}</p>`;
        });
        this.question.self_answer = showStringAnswer;
      }
      // }
    }
    // if (this.question.typeCode == "E" && this.question.blankCount != 0) {
    //   let originAnswerLength = 0;
    //   try {
    //     let handledAnswer1 = eval('(' + this.question.answer + ')');
    //     originAnswerLength = handledAnswer1.length;
    //     let showStringAnswer1 = "";
    //     if (handledAnswer1.length) {
    //       handledAnswer1.forEach((item) => {
    //         showStringAnswer1 += `<p>${item.orderno}. ${item.answer}</p>`;
    //       });
    //       this.question.answer = showStringAnswer1 || '未作答';
    //     }
    //   }
    //   catch (err) {
    //     console.log(err)
    //   }
    //   // if (this.question.answerUnicity) {
    //   //   let showStringAnswer = "";
    //   //   let paper_answers = [];
    //   //   let handledAnswer = eval('(' + this.question.self_answer + ')'); //此处是字符串,要转化为json,数据的最后有一个多余的逗号,使用JSON.parse解析会报错,要用eval来解析
    //   //   if (handledAnswer) {
    //   //     debugger;
    //   //     handledAnswer.forEach((item) => {
    //   //       if (!item.self_answer) item.self_answer = "未作答";
    //   //       let questionNum = +this.question.originalName.split('-')[0] || 1
    //   //       showStringAnswer += `<p>${item.orderno + (questionNum - 1)}. ${item.self_answer}</p>`;
    //   //     });
    //   //     this.question.self_answer = showStringAnswer;
    //   //   }
    //   // } else {
    //   let originalName = this.question.originalName;
    //   let start = originalName.split("-")[0]

    //   if (typeof this.question.self_answer == 'string') {
    //     // let text = this.question.self_answer.replace(/<[^>]+>/g,'');
    //     let handledAnswer1 = eval('(' + this.question.self_answer + ')');
    //     let showStringAnswer1 = "";
    //     // let oanswer = eval('(' + this.question.answer + ')');
    //     handledAnswer1 = handledAnswer1.slice(0, originAnswerLength);
    //     console.log("handledAnswer1==>", handledAnswer1)
    //     if (handledAnswer1.length) {
    //       handledAnswer1.forEach((item, index) => {
    //         // showStringAnswer1 += `<p>${item.orderno}. ${item.self_answer || '未作答2'} </p>`;
    //         showStringAnswer1 += `<p>${(+start + index)}. ${item.self_answer || '未作答'} </p>`;
    //       });

    //       this.question.self_answer = showStringAnswer1 || '未作答';
    //     }
    //   } else {
    //     let showStringAnswer1 = "";
    //     this.question.self_answer.forEach((item, index) => {
    //       showStringAnswer1 += `<p>${(+start + index)}. ${item.self_answer || '未作答'} </p>`;
    //     });

    //     this.question.self_answer = showStringAnswer1 || '未作答';
    //   }
    //   // }
    // }
    //七选五的解析 analysis
    if (this.question.typeId == 40) {
      let handledAnswer = eval("(" + this.question.analysis + ")");
      let showStringAnswer = "";
      if (handledAnswer) {
        handledAnswer.forEach((item) => {
          showStringAnswer += `<p>${item.orderno}. ${item.analysis}</p>`;
        });
        this.question.analysis = showStringAnswer;
      }
    }
    // 填空题解析 analysis
    if (this.question.typeCode == "E" && this.question.blankCount > 0) {
      let handledAnswer1 = eval("(" + this.question.analysis + ")");
      let showStringAnswer1 = "";
      if (handledAnswer1.length) {
        handledAnswer1.forEach((item) => {
          showStringAnswer1 += `<p>${item.orderno}. ${item.analysis}</p>`;
        });
        this.question.analysis = showStringAnswer1 || '略';
      }
    }
    this.$root.eventHub.$on("fontsize", (size) => {
      this.setFontSize = size;
    });
  },
};
</script>

<style lang="scss" scoped>
/deep/ .gaicuo {
  padding: 30px;
  padding-top: 80px;
  padding-bottom: 100px;
}

/deep/ .el-image-viewer__canvas img {
  background-color: #fff !important;
}

.title {
  margin-top: 30px;
  background-color: #f5f5f5;
  position: relative;

  .question_type {
    width: 1400px;
    position: absolute;
    top: 20px;
    height: 60px;
    margin-left: -27px;
    background-color: #ffffff;
    border-radius: 50px 50px 50px 50px;
    z-index: 10;

    .cricle {
      width: 60px;
      height: 60px;
      border-radius: 30px;
      border: 2px solid #dddddd;
      position: absolute;
      z-index: 0;
      margin: 0;
      padding: 0;
    }

    .mask {
      z-index: 9;
      width: 30px;
      height: 60px;
      background-color: #ffffff;
      margin-left: 30px;
      position: absolute;
    }

    .id {
      z-index: 10;
      min-width: 47px;
      height: 47px;
      width: auto;
      border-radius: 47px;
      background-color: #7eb8ff;
      margin-top: 6.5px;
      color: #ffffff;
      font-size: 19px;
      line-height: 47px;
      text-align: center;
      position: absolute;
      float: left;
      margin-left: 6.5px;
    }

    .name {
      width: calc(100% - 105px);
      font-size: 24px;
      color: #ababab;
      position: absolute;
      float: left;
      margin-top: 10px;
      margin-left: 70px;
    }

    .score {
      margin-left: 95px;
    }

    .get-score {
      width: 700px;
      height: 60px;
      float: right;

      .text {
        width: auto;
        font-size: #ababab;
        height: 60px;
        float: left;
      }

      .select {
        width: auto;
        font-size: #ababab;
        height: 60px;
        line-height: 60px;
        display: inline-flex;
        margin-left: 80px;
        float: left;
        margin-left: 20px;

        div {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }

        .gray_right {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_true.png");
        }

        .right {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/true.png");
        }

        .gray_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_false.png");
        }

        .error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/false.png");
        }

        .gray_right_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_false_true.png");
        }

        .right_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/true_false.png");
        }
      }
    }

    .divs {
      float: right;
      // margin-right: 345px;

      /deep/ .el-select {
        width: 120px;

        .el-input.is-focus .el-input__inner {
          border-color: #5c307d;
        }

        .el-input__inner {
          font-size: 16px;
        }
      }

      .text {
        font-size: 24px;
        color: #ababab;
      }
    }
  }

  .question_content {
    border: 2px solid #dddddd;
    background-color: #ffffff;
    width: 100%;
    position: relative;
    margin-left: 0px;
    padding-bottom: 40px;

    .topic {
      width: 1400px;
      margin-top: 80px;
      color: #3c3c3c;
      line-height: 1.5;
      margin-left: 40px;
      display: inline-block;

      >>>.text {
        font-family: "Times New Roman", "Microsoft YaHei", SimHei;
        font: "Times New Roman", "Microsoft YaHei", SimHei;

        /deep/ p {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal
        }

        /deep/ p span {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal
        }
      }

      .format_data_gaicuo {
        line-height: 2.5;
      }

      /deep/ img {
        vertical-align: middle;
      }
    }

    .options {
      margin-left: 90px;
      width: 100%;

      >>>.text {
        font-family: "Times New Roman", "Microsoft YaHei", SimHei;
        font: "Times New Roman", "Microsoft YaHei", SimHei;
      }

      .option {
        width: 1320px;
        margin-top: 10px;
        font-size: 18px;
        color: #3c3c3c;
        line-height: 1.5;
        word-wrap: break-word;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.title_c {
  width: 1506px;
  position: relative;
  margin-left: 33px;

  // margin-top : -30px;
  .question_type {
    width: 1400px;
    position: absolute;
    top: 20px;
    height: 60px;
    background-color: #ffffff;
    border-radius: 50px 50px 50px 50px;
    z-index: 10;
    margin-left: 70px;

    .id {
      z-index: 10;
      min-width: 47px;
      height: 47px;
      width: auto;
      border-radius: 47px;
      background-color: #7eb8ff;
      margin-top: 6.5px;
      color: #ffffff;
      font-size: 19px;
      line-height: 47px;
      text-align: center;
      position: absolute;
      float: left;
      margin-left: 6.5px;
      display: none;
    }

    .name {
      width: calc(100% - 105px);
      font-size: 24px;
      color: #ababab;
      position: absolute;
      float: left;
      margin-top: 10px;
      margin-left: 15px;
    }

    .score {
      margin-left: 95px;
    }

    .get-score {
      width: 700px;
      height: 60px;
      float: right;

      .text {
        width: auto;
        font-size: #ababab;
        height: 60px;
        float: left;
      }

      .select {
        width: auto;
        font-size: #ababab;
        height: 60px;
        line-height: 60px;
        display: inline-flex;
        margin-left: 80px;
        float: left;
        margin-left: 20px;

        div {
          background-repeat: no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }

        .gray_right {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_true.png");
        }

        .right {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/true.png");
        }

        .gray_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_false.png");
        }

        .error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/false.png");
        }

        .gray_right_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/gray_false_true.png");
        }

        .right_error {
          width: 43px;
          height: 36px;
          background-image: url("../../../../assets/images/assessment/true_false.png");
        }
      }
    }

    .divs {
      float: right;
      // margin-right: 345px;

      /deep/ .el-select {
        width: 120px;

        .el-input.is-focus .el-input__inner {
          border-color: #5c307d;
        }

        .el-input__inner {
          font-size: 16px;
        }
      }

      .text {
        font-size: 24px;
        color: #ababab;
      }
    }
  }

  .question_content {
    border: 2px solid #dddddd;
    background-color: #ffffff;
    width: 100%;
    position: relative;
    margin-left: 57px;
    padding-bottom: 40px;

    .topic {
      width: 1400px;
      margin-top: 80px;
      color: #3c3c3c;
      line-height: 1.5;
      margin-left: 25px;

      .format_data_gaicuo {
        line-height: 2.5;
      }

      >>>.text {
        font-family: "Times New Roman", "Microsoft YaHei", SimHei;
        font: "Times New Roman", "Microsoft YaHei", SimHei;

        /deep/ p {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal
        }

        /deep/ p span {
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: normal
        }
      }

      >>>img {
        vertical-align: middle;
      }
    }

    .options {
      margin-left: 90px;
      width: 100%;

      >>>.text {
        font-family: "Times New Roman", "Microsoft YaHei", SimHei;
        font: "Times New Roman", "Microsoft YaHei", SimHei;
      }

      .option {
        width: 1320px;
        margin-top: 10px;
        font-size: 18px;
        color: #3c3c3c;
        line-height: 1.5;
        word-wrap: break-word;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.wrong_topic {
  height: 624px;
  width: 100%;
  margin-top: 80px;

  .left {
    width: 45%;
    float: left;
    height: 625px;
    margin-left: 3%;
    border: 1px solid #cf99ff;
  }

  .right {
    float: right;
    width: 45%;
    height: 624px;
    margin-right: 3%;

    .top {
      width: 100%;
      border: 1px solid #cf99ff;
      height: 248px;
      overflow: auto;
    }

    .bottom {
      border: 1px solid #cf99ff;
      height: 345px;
      width: 100%;
      margin-top: 30px;
    }
  }

  .assessment {
    width: 100%;
    background-color: #ffffff;
    position: relative;
    font-size: 20px;
    height: 100%;

    .texts {
      width: 100%;
      height: 48px;
      font-size: 18px;
      color: #3c3c3c;
      border-bottom: 1px #5c307d solid;
      line-height: 48px;
      position: sticky;
      top: 0;
      background-color: #fff;
      z-index: 2;

      /deep/ .el-icon-caret-bottom {
        float: right;
        margin-right: 20px;
        cursor: pointer;
        margin-top: 15px;
      }

      /deep/ .el-icon-caret-top {
        float: right;
        margin-right: 20px;
        cursor: pointer;
        margin-top: 15px;
      }
    }

    .radios {
      position: absolute;
      top: 58px;
      right: 15px;
      bottom: 15px;
      left: 15px;
      overflow: auto;
      z-index: 5;

      .content {
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        font-size: 20px;
        line-height: 44px;

        // overflow : auto;
        .solution {
          width: 100%;
          font-size: 22px;

          >>>.el-button {
            height: 44px;
            width: 200px;
            font-size: 24px;
            color: #fff;
            border-radius: 22px;
            background-color: #5c307d;
            float: right;
            margin-right: 20px;
            line-height: 0.8;
          }

          /deep/ img {
            vertical-align: middle;
          }
        }

        .images {
          /deep/ img {
            width: 100% !important;
            height: auto;
            cursor: pointer;
            margin-top: 5px;
            white-space: pre-line;
          }

          /deep/ p {
            white-space: pre-line;
          }
        }

        .uncorrect {
          padding: 30px auto 30px 10px;
        }

        /deep/ .el-dialog {
          height: auto;

          .el-button {
            width: 158px;
            height: 40px;
            border-radius: 20px;
            font-size: 20px;
            line-height: 0.8;
            margin-top: 30px;
          }

          .el-button--primary {
            background-color: #5c307d;
          }
        }

        /deep/ .el-dialog__wrapper {
          .el-dialog__header {
            padding: 0;
            background-color: #5c307d;
            font-size: 24px;
            height: 60px;

            .el-dialog__title {
              line-height: 60px;
              font-size: 24px;
              color: #ffffff;
            }
          }

          .el-dialog__body {
            .pic-list {
              width: 100%;
              height: 130px;
              display: flex;
              justify-content: space-evenly;
              align-items: center;

              img {
                width: 66px;
                height: 66px;
                cursor: pointer;
              }
            }

            .num-score {
              width: 100%;
              text-align: center;
              font-size: 24px;
              margin-top: 10px;

              .input-score {
                width: 62px;
                height: 40px;
                border: 1px solid #dbdbdb;
                font-size: 26px;
                text-align: center;
              }
            }

            border-bottom: 1px solid #cf8eff;
          }
        }

        img {
          width: 65px;
          height: 65px;
        }
      }
    }
  }
}
</style>
<style lang="stylus">
.font-set {
  .el-select-dropdown__wrap {
    max-height: none;
  }

  .el-scrollbar__wrap {
    .el-select-dropdown__list {
      .el-select-dropdown__item {
        height: 50px;
        line-height: 50px;
      }

      .el-select-dropdown__item:nth-child(1) {
        font-size: 18px;
      }

      .el-select-dropdown__item:nth-child(2) {
        font-size: 20px;
      }

      .el-select-dropdown__item:nth-child(3) {
        font-size: 22px;
      }

      .el-select-dropdown__item:nth-child(4) {
        font-size: 24px;
      }

      .el-select-dropdown__item:nth-child(5) {
        font-size: 26px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.radios-bottom {
  position: absolute;
  top: 58px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  overflow: auto;
}

.radios-top {
  position: absolute;
  top: 58px;
  right: 15px;
  bottom: 15px;
  left: 15px;
  overflow: auto;
}

/deep/ .pic-dialog {
  width: 800px;
  height: 950px;
  z-index: 999;


  .el-dialog__header {
    width: 100%;
    height: 50px;
    position: relative;
    float: left;
    padding: 0;
    line-height: 50px;
    text-align: center;
  }

  .el-dialog__body {
    width: 100%;
    height: 900px;
    position: relative;
    float: left;
    padding: 0;
    top: 0;

    ::-webkit-scrollbar {
      width: 0 !important;
    }

    ::-webkit-scrollbar {
      width: 0 !important;
      height: 0;
    }

    .left {
      width: 15%;
      height: 100%;
      position: relative;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .prev {
        width: auto;
        height: auto;

        .el-button el-button--primary {
          color: #FFF;
          border: none;
        }

        .el-button {
          color: #FFF;
          border: none;
          width: 50px;
          ;
          height: 50px;
          border-radius: 25px;
          padding: 0;
          margin: 0;

          .el-icon-arrow-left {
            font-size: 28px;
          }
        }
      }
    }

    .img {
      width: 70%;
      height: 90%;
      position: relative;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow-y: scroll;
      padding-top: 5%;
      padding-bottom: 5%;

      img {
        width: 100%;
      }
    }

    .edit {
      width: 100%;
      height: auto;
      text-align: center;
      position: absolute;
      bottom: 0;
    }

    .right {
      width: 15%;
      height: 100%;
      position: relative;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .next {
        width: auto;
        height: auto;

        .el-button el-button--primary {
          color: #FFF;
          border: none;
        }

        .el-button {
          color: #FFF;
          border: none;
          width: 50px;
          ;
          height: 50px;
          border-radius: 25px;
          padding: 0;
          margin: 0;

          .el-icon-arrow-right {
            font-size: 28px;
          }
        }
      }
    }
  }
}
</style>

